(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ZUGCoasterNativeRate = api;
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var SUPPORTED_PIECES = [5, 25, 50, 100, 250, 500];
  var MINIMUM_PIECES = SUPPORTED_PIECES[0];
  var MAXIMUM_PIECES = SUPPORTED_PIECES[SUPPORTED_PIECES.length - 1];
  var EXPECTED_UNIT_PRICES = {
    single: { 5: 160, 25: 144, 50: 124, 100: 84, 250: 55, 500: 43 },
    double: { 5: 232, 25: 209, 50: 180, 100: 122, 250: 80, 500: 62 }
  };
  var ALLOWED_PUBLIC_KEYS = [
    'Shape',
    'Finished Size',
    'Pieces',
    'Material',
    'Print Style',
    'Turnaround',
    'Artwork Status'
  ];
  var FORBIDDEN_KEYS = [
    'Product',
    'Original Artwork',
    'Proof Preview',
    'Artwork Note',
    'Job ID',
    'calc_line_uid',
    '_pricing_engine',
    '_line_type',
    '_upload_id',
    '_artwork_mode',
    '_artwork_approved',
    '_artwork_original_url',
    '_dcf_preview_url',
    '_calc_data',
    '_job_id',
    '_carrier_strategy',
    '_carrier_contract',
    '_carrier_profile',
    '_carrier_source_product_id',
    '_bundle_quantity_locked',
    '_bundle_display_quantity',
    '_coaster_front_upload_id',
    '_coaster_back_upload_id'
  ];

  function positiveInteger(value) {
    var number = Number(value);
    return Number.isInteger(number) && number > 0 ? number : 0;
  }

  function normalizedText(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function firstValue(source, keys) {
    for (var index = 0; index < keys.length; index += 1) {
      var value = source[keys[index]];
      if (value !== undefined && value !== null && String(value).trim()) {
        return String(value).trim();
      }
    }
    return '';
  }

  function prepare(raw) {
    if (!raw || raw.schemaVersion !== 2 ||
        raw.status !== 'production_coaster_native_rate' ||
        raw.family !== 'coaster' ||
        raw.contractVersion !== 'coaster_native_piece_v2' ||
        !raw.contract || raw.contract.exactRepresentationsOnly !== true ||
        raw.contract.hiddenDollarCentFallback !== false ||
        raw.contract.quantityMode !== 'customer_pieces' ||
        raw.contract.customerInputsRemainDynamic !== false ||
        positiveInteger(raw.contract.offerCount) !== 12 ||
        !Array.isArray(raw.contract.supportedPieces) ||
        raw.contract.supportedPieces.join(',') !== SUPPORTED_PIECES.join(',') ||
        !raw.sourceProduct || positiveInteger(raw.sourceProduct.productId) !== 6559933038655 ||
        raw.sourceProduct.handle !== 'custom-coasters' ||
        raw.sourceProduct.recipeId !== 'coaster' ||
        !Array.isArray(raw.sourceProduct.activationTags) ||
        raw.sourceProduct.activationTags.length !== 1 ||
        raw.sourceProduct.activationTags[0] !== 'ZUG_MAT:coaster' ||
        !raw.product || positiveInteger(raw.product.productId) !== 8294100893759 ||
        raw.product.handle !== 'coaster-native-rate' ||
        !Array.isArray(raw.product.offers) || raw.product.offers.length !== 12) {
      throw new Error('Coaster native-rate catalog contract is invalid.');
    }

    var seenOffers = {};
    var seenVariants = {};
    var seenSkus = {};
    var offers = raw.product.offers.map(function (entry) {
      var pieces = positiveInteger(entry.pieces);
      var printStyle = String(entry.printStyle || '').trim().toLowerCase();
      var unitPriceCents = positiveInteger(entry.unitPriceCents);
      var variantId = positiveInteger(entry.variantId);
      var sku = String(entry.sku || '').trim();
      var offerKey = printStyle + '_' + pieces;
      var expectedSku = 'ZUG-COASTER-NATIVE-' +
        (printStyle === 'double' ? 'D' : 'S') + String(pieces).padStart(3, '0');
      var expectedTitle = (printStyle === 'double' ? 'Double ' : 'Single ') + pieces;
      if (SUPPORTED_PIECES.indexOf(pieces) === -1 ||
          !EXPECTED_UNIT_PRICES[printStyle] ||
          unitPriceCents !== EXPECTED_UNIT_PRICES[printStyle][pieces] ||
          entry.offerKey !== offerKey || !variantId || !sku ||
          seenOffers[offerKey] || seenVariants[variantId] || seenSkus[sku] ||
          sku !== expectedSku || String(entry.title || '') !== expectedTitle) {
        throw new Error('Coaster native offer mapping is invalid or duplicated.');
      }
      seenOffers[offerKey] = true;
      seenVariants[variantId] = true;
      seenSkus[sku] = true;
      return {
        offerKey: offerKey,
        pieces: pieces,
        printStyle: printStyle,
        unitPriceCents: unitPriceCents,
        variantId: variantId,
        sku: sku,
        title: String(entry.title || '')
      };
    });

    ['single', 'double'].forEach(function (printStyle) {
      SUPPORTED_PIECES.forEach(function (pieces) {
        if (!seenOffers[printStyle + '_' + pieces]) {
          throw new Error('Coaster native offer set is incomplete.');
        }
      });
    });

    return {
      version: raw.contractVersion,
      supportedPieces: raw.contract.supportedPieces.slice(),
      sourceProduct: {
        productId: positiveInteger(raw.sourceProduct.productId),
        handle: raw.sourceProduct.handle,
        recipeId: raw.sourceProduct.recipeId,
        activationTags: raw.sourceProduct.activationTags.slice()
      },
      product: {
        productId: positiveInteger(raw.product.productId),
        title: String(raw.product.title || ''),
        handle: raw.product.handle,
        offers: offers
      }
    };
  }

  function classify(input, contract) {
    input = input || {};
    var productId = positiveInteger(input.productId);
    var handle = String(input.handle || '');
    var recipeId = String(input.recipeId || '');
    var eligible = productId === 6559933038655 || handle === 'custom-coasters';
    if (!eligible) return { eligible: false, active: false, reason: 'different_product' };
    if (!contract || !contract.sourceProduct) {
      return { eligible: true, active: false, reason: 'catalog_unavailable' };
    }
    if (productId !== contract.sourceProduct.productId) {
      return { eligible: true, active: false, reason: 'wrong_product_id' };
    }
    if (handle !== contract.sourceProduct.handle) {
      return { eligible: true, active: false, reason: 'wrong_handle' };
    }
    if (recipeId !== contract.sourceProduct.recipeId) {
      return { eligible: true, active: false, reason: 'wrong_recipe' };
    }
    var tags = (input.tags || []).map(String);
    if (tags.indexOf(contract.sourceProduct.activationTags[0]) === -1) {
      return { eligible: true, active: false, reason: 'missing_activation_tag' };
    }
    return { eligible: true, active: true, reason: 'coaster_native_rate' };
  }

  function resolve(totalCents, pieces, doubleSided, contract) {
    var target = positiveInteger(totalCents);
    var customerPieces = positiveInteger(pieces);
    if (!target || !contract || !contract.product ||
        !Array.isArray(contract.product.offers) ||
        !Array.isArray(contract.supportedPieces) ||
        contract.supportedPieces.join(',') !== SUPPORTED_PIECES.join(',') ||
        SUPPORTED_PIECES.indexOf(customerPieces) === -1) {
      throw new Error('Coaster native-rate pricing input is invalid.');
    }
    var printStyle = doubleSided === true ? 'double' : 'single';
    var offer = contract.product.offers.find(function (entry) {
      return entry.pieces === customerPieces && entry.printStyle === printStyle;
    });
    var expectedTotal = offer ? offer.unitPriceCents * customerPieces : 0;
    if (!offer || target !== expectedTotal) {
      throw new Error('Coaster total does not match the approved native offer.');
    }
    return {
      contractVersion: contract.version,
      targetTotalCents: target,
      unitPriceCents: offer.unitPriceCents,
      variantId: offer.variantId,
      sku: offer.sku,
      customerPieces: customerPieces,
      printStyle: printStyle,
      nativeTotalCents: expectedTotal
    };
  }

  function buildPricingResult(pricing, width, height, rushOption) {
    if (!pricing || !positiveInteger(pricing.qty) ||
        !Number.isFinite(Number(pricing.total)) || Number(pricing.total) <= 0) {
      return null;
    }
    var exactUnit = Number(pricing.total) / pricing.qty;
    var area = Number(width) * Number(height);
    return {
      total: Number(pricing.total),
      unitPrice: Number(pricing.unitPrice),
      quantity: pricing.qty,
      areaSqIn: area,
      isCoaster: true,
      v2: {
        version: 'coaster_piece_v2',
        width_in: Number(width),
        height_in: Number(height),
        area_in2: area,
        size_tier_in2: area,
        qty_entered: pricing.qty,
        q_low: pricing.tierLow,
        q_high: pricing.tierHigh,
        u_low: Number(pricing.unitPrice),
        u_high: Number(pricing.unitPrice),
        u_interp: exactUnit,
        u_final: exactUnit,
        global_base_scalar: 1,
        material_key: 'coaster',
        material_mult: 1,
        size_mult: 1,
        rush_option: rushOption || 'regular',
        rush_mult: 1,
        total_desired: Number(pricing.total),
        unit_price: exactUnit,
        quantity: pricing.qty
      }
    };
  }

  function validationMessage(pieces) {
    var quantity = Number(pieces);
    return !Number.isInteger(quantity) || SUPPORTED_PIECES.indexOf(quantity) === -1
      ? 'Choose 5, 25, 50, 100, 250, or 500 pieces.'
      : 'Coaster pricing is temporarily unavailable.';
  }

  function cleanProperties(input, contract, uid, pieces, source) {
    var raw = Object.assign({}, input || {});
    var properties = {};
    ALLOWED_PUBLIC_KEYS.forEach(function (key) {
      var value = String(raw[key] || '').trim();
      if (value) properties[key] = value;
    });
    properties.Pieces = String(positiveInteger(pieces));
    properties._calc_line_uid = String(uid || '').trim();
    properties._is_coaster_native = 'true';

    var isDoubleSided = String(raw._coaster_double_sided || '').toLowerCase() === 'true';
    properties.Material = 'Coaster Board';
    properties['Print Style'] = isDoubleSided ? 'Double-Sided' : 'Single-Sided';
    var frontOriginal = firstValue(raw, [
      '_coaster_front_original_url', '_original_artwork',
      '_artwork_original_url', 'Original Artwork'
    ]);
    var frontPreview = firstValue(raw, [
      '_coaster_front_rendered_preview_url', '_coaster_front_preview_url',
      '_proof_preview', '_dcf_preview_url', 'Proof Preview'
    ]);

    if (isDoubleSided) {
      var backOriginal = firstValue(raw, ['_coaster_back_original_url']);
      var backPreview = firstValue(raw, [
        '_coaster_back_rendered_preview_url', '_coaster_back_preview_url'
      ]);
      properties._coaster_double_sided = 'true';
      if (frontOriginal) properties._coaster_front_original_url = frontOriginal;
      if (frontPreview && frontPreview !== frontOriginal) {
        properties._coaster_front_preview_url = frontPreview;
      }
      if (backOriginal) properties._coaster_back_original_url = backOriginal;
      if (backPreview && backPreview !== backOriginal) {
        properties._coaster_back_preview_url = backPreview;
      }
    } else {
      if (frontOriginal) properties._original_artwork = frontOriginal;
      if (frontPreview && frontPreview !== frontOriginal) {
        properties._proof_preview = frontPreview;
      }
    }

    source = source || {};
    var sourceTitle = String(source.title || '').trim();
    var sourceUrl = String(source.url || '').trim();
    var sourceImage = String(source.image || '').trim();
    if (sourceTitle) properties._product_title = sourceTitle;
    if (sourceUrl) properties._storefront_product_url = sourceUrl;
    if (sourceImage) properties._storefront_product_image = sourceImage;
    if (sourceTitle && normalizedText(sourceTitle) !== normalizedText(contract.product.title)) {
      properties.Product = sourceTitle;
    }

    if (!properties._calc_line_uid || properties.Pieces === '0') {
      throw new Error('Coaster line identity is invalid.');
    }
    return properties;
  }

  function buildLine(input) {
    input = input || {};
    var resolution = resolve(input.totalCents, input.pieces, input.doubleSided === true, input.contract);
    return {
      item: {
        id: resolution.variantId,
        quantity: resolution.customerPieces,
        properties: cleanProperties(
          input.properties,
          input.contract,
          input.uid,
          input.pieces,
          input.source
        )
      },
      resolution: resolution
    };
  }

  function verifyCartLine(item, resolution, uid, pieces) {
    var properties = item && item.properties ? item.properties : {};
    var publicKeys = Object.keys(properties).filter(function (key) {
      return key.charAt(0) !== '_';
    });
    return Boolean(item && resolution &&
      Number(item.variant_id || item.id) === Number(resolution.variantId) &&
      Number(item.quantity) === Number(resolution.customerPieces) &&
      Number(item.final_line_price) === Number(resolution.targetTotalCents) &&
      properties._calc_line_uid === uid &&
      properties._is_coaster_native === 'true' &&
      String(properties.Pieces) === String(pieces) &&
      publicKeys.every(function (key) { return ALLOWED_PUBLIC_KEYS.indexOf(key) !== -1; }) &&
      FORBIDDEN_KEYS.every(function (key) {
        return !Object.prototype.hasOwnProperty.call(properties, key);
      }));
  }

  function verifyCart(cart, resolution, uid, pieces) {
    var lines = (cart && cart.items || []).filter(function (item) {
      return item.properties && item.properties._calc_line_uid === uid;
    });
    return lines.length === 1 && verifyCartLine(lines[0], resolution, uid, pieces);
  }

  return {
    minimumPieces: MINIMUM_PIECES,
    maximumPieces: MAXIMUM_PIECES,
    supportedPieces: SUPPORTED_PIECES.slice(),
    expectedUnitPrices: JSON.parse(JSON.stringify(EXPECTED_UNIT_PRICES)),
    allowedPublicKeys: ALLOWED_PUBLIC_KEYS.slice(),
    forbiddenKeys: FORBIDDEN_KEYS.slice(),
    prepare: prepare,
    classify: classify,
    resolve: resolve,
    buildPricingResult: buildPricingResult,
    validationMessage: validationMessage,
    cleanProperties: cleanProperties,
    buildLine: buildLine,
    verifyCartLine: verifyCartLine,
    verifyCart: verifyCart
  };
});
